<template>
    <div>
      <b-card title="E-Learning Setup" class="mb-4 shadow-sm">
        <!-- Header Section -->
        <div class="d-flex flex-column flex-md-row justify-content-between align-items-center mb-4">
          <div class="mb-2 mb-md-0">
            <h4 class="mb-0">Manage Setup</h4>
            <p class="text-muted mb-0">Configure your E-Learning store settings here.</p>
          </div>
          <div>
            <b-button v-if="this.totalEntries === 0" variant="success" class="mx-2" @click="showAddLearningModal = true">
              <feather-icon
              icon="UserIcon"
              size="16"
            />
             Register Admin
            </b-button>
            <b-button variant="outline-primary" @click="redirectToStore">
              <feather-icon
                icon="BookIcon"
                size="16"
              />
              Visit Website
      </b-button>
          </div>
        </div>

        
  
        <!-- Add User Modal -->
        <b-modal v-model="showAddLearningModal" title="Setup E-learning" hide-footer centered>
          <template #modal-header>
            <div class="d-flex align-items-center">
              <b-icon icon="gear" class="me-2"></b-icon>
              <h5 class="mb-0">Setup E-learning</h5>
            </div>
          </template>
   
          <validation-observer ref="addUser" #default="{ invalid }">
          <b-form @submit.prevent="addUser">

             <!-- Username -->
             <b-form-group label="Full Name" label-for="fullName">
              <validation-provider #default="{ errors }" name="Full Name" vid="Full Name" rules="required">
                <b-form-input
                  id="fullName"
                  v-model="newUser.fullName"
                  placeholder="Enter fullName"
                ></b-form-input>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
              </b-form-group>
  
              
            <!-- Email -->
            <b-form-group label="Email" label-for="email">
              <validation-provider #default="{ errors }" name="Email" vid="Email" rules="required">
              <b-form-input
                type="email"
                id="email"
                v-model="newUser.email"
                placeholder="Enter email"
              ></b-form-input>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            </b-form-group>
  
           
            <!-- Password -->
            <b-form-group label="Password" label-for="password">
              <validation-provider #default="{ errors }" name="Password" vid="Password" rules="required">
              <b-form-input
                type="password"
                id="password"
                v-model="newUser.password"
                placeholder="Enter password"
              ></b-form-input>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            </b-form-group>
  
            <!-- Form Actions -->
            <div class="d-flex justify-content-end gap-2 mt-4">
              <b-button variant="secondary" @click="showAddLearningModal = false">
                Cancel
              </b-button>
              <b-button type="button" @click="addUser" variant="primary"  class="ml-2">
                Submit
              </b-button>
            </div>
          </b-form>
        </validation-observer>
        </b-modal>
      </b-card>

      <div>
        <b-card title="E-Learning User" class="mb-4">
          <b-form-group label="Search">
            <b-form-input
              v-model="searchQuery"
              placeholder="Search by name or email"
            ></b-form-input>
          </b-form-group>
          <b-table 
            :items="filteredUserEntries" 
            :fields="fields" 
            responsive="sm" 
            bordered 
            :per-page="perPage" 
            :current-page="currentPage"
          >
          </b-table>
          <div class="d-flex justify-content-between align-items-center mt-3">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <div>
                <label for="perPage" class="form-label">Per page</label>
                <b-form-select id="perPage" v-model="perPage" :options="perPageOptions" class="w-auto ml-2"></b-form-select>
              </div>
            </div>
            <div>
              Showing {{ firstItem }} to {{ lastItem }} of {{ totalEntries }} entries
            </div>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalEntries"
              :per-page="perPage"
              align="right"
              size="sm"
            ></b-pagination>
          </div>
        </b-card>
      </div>
    </div>
  </template>
  
  <script>
  import {
    BTable,
    BButton,
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BCard,
    BPagination,
    BFormSelect,
    BIcon,
    BFormInvalidFeedback
  } from "bootstrap-vue";
  import { mapActions, mapGetters } from "vuex";
  import { ValidationProvider, ValidationObserver } from "vee-validate";
  
  export default {
    components: {
      BTable,
      BButton,
      BModal,
      BForm,
      BFormGroup,
      BFormInput,
      BCard,
      BPagination,
      BFormSelect,
      BIcon,
      BFormInvalidFeedback,
      ValidationProvider,
      ValidationObserver,
    },
    data() {
      return {
        searchQuery: "",
        showAddLearningModal: false,
        newUser: {
          email: "",
          fullName: "",
          password: "",
        },
        fields: [
        { key: "fullName", label: "fullName", sortable: true },
        { key: "email", label: "Email", sortable: true },
      ],
      perPageOptions: [5, 10, 15, 20],
      perPage: 5,
      currentPage: 1,
      };
    },
    computed: {
      ...mapGetters("exportModule", { 
    userEntries: "elearn", // Vuex mapping
  }),
  userEntries() {
    return Array.isArray(this.$store.getters["elearnModule/elearn"])
      ? this.$store.getters["elearnModule/elearn"]
      : [];
  },
  filteredUserEntries() {
  
  if (!Array.isArray(this.userEntries)) {
    console.error("userEntries is not an array:", this.userEntries);
    return [];
  }

  let filtered = this.userEntries.filter(user =>
    user.fullName?.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
    user.email?.toLowerCase().includes(this.searchQuery.toLowerCase())
  );

  return filtered.slice((this.currentPage - 1) * this.perPage, this.currentPage * this.perPage);
},

  totalEntries() {
    return (this.userEntries || []).filter(user =>
      user.fullName?.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
      user.email?.toLowerCase().includes(this.searchQuery.toLowerCase())
    ).length;
  },

  firstItem() {
    return (this.userEntries || []).length ? (this.currentPage - 1) * this.perPage + 1 : 0;
  },

  lastItem() {
    const last = this.currentPage * this.perPage;
    return last > this.totalEntries ? this.totalEntries : last;
  },
      validateEmail() {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(this.newUser.email);
      },
      validateFullName() {
        return this.newUser.fullName.length > 0;
      },
      validatePassword() {
        const passwordRegex = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{8,15}$/;
        return passwordRegex.test(this.newUser.password);
      },
      isFormInvalid() {
        return (
          !this.validateEmail ||
          !this.validateFullName ||
          !this.validatePassword
        );
      },
    },
    methods: {
      ...mapActions("elearnModule", ["postAdminAction", "getUserListAction"]),
  
      redirectToStore() {
        const tenantName = localStorage.getItem("userTenant");
        if (tenantName) {
          const storeUrl = `${process.env.VUE_APP_ELEARN_URL}`;
  
          window.open(storeUrl, "_blank");
        } else {
          alert("Tenant name not found!");
        }
      },
  
      async addUser() {
        let isValid = await this.$refs.addUser.validate();
      if (isValid) {
        const loader = this.$swal({
          title: "Processing...",
          text: "Please wait while the processing data",
          onOpen: () => {
            this.$swal.showLoading();
          },
          allowOutsideClick: () => !this.$swal.isLoading(),
          buttonsStyling: false,
          showConfirmButton: false,
        });
  
        const payload = {
          email: this.newUser.email,
          fullName: this.newUser.fullName,
          password: this.newUser.password,
          tenantId: localStorage.getItem("userTenant")
        };
  
        try {
          const response = await this.postAdminAction(payload);
          console.log("Admin registration response:", response);
if (response.status === "success") {
  this.$swal("Success", "Admin added successfully!", "success");
  await this.loadUsers();
} else if (response.status === "duplicate"){
  this.$swal("Error", "Admin Already exists Please try again.", "error");
}
else {
  this.$swal("Error", "Unexpected response. Please try again.", "error");
}
          this.showAddLearningModal = false;
          this.newUser = {
            email: "",
            fullName: "",
            password: "",
            shopName: "",
          };     

        } catch (error) {
          this.$swal("Error", "Failed to add admin.", "error");
          console.error(error);
        }
      }
      },
      async loadUsers(){
        try {
    const tenantName = localStorage.getItem("userTenant");
    await this.getUserListAction(tenantName); // Vuex will update the state automatically
  } catch (error) {
    console.error("Error fetching user list:", error);
  }
 
      }
    },
    async mounted() {
    await this.loadUsers();
}
  };
  </script>